import { LayoutGrid, Plus } from "lucide-react"
import StyledSelectDropdown from "../StyledSelectDropdown"
import { FormField } from "./CreateJobFields"

type EducationRequirement = {
    qualificationId: number | null
    fieldOfStudyId: number | null
    fieldOfStudyOtherName: string | null
}

type EducationalRequirementsSectionProps = {
    isEditMode: boolean
    educationRequirements: EducationRequirement[]
    qualifications: any[]
    qualificationsStatus: string
    fieldsOfStudy: any[]
    fieldsOfStudyStatus: string
    otherFieldOfStudyOption: { id: string; name: string }
    addEducationRequirement: () => void
    removeEducationRequirement: (index: number) => void
    handleEducationRequirementChange: (index: number, field: "qualificationId" | "fieldOfStudyId", value: string) => void
    handleFieldOfStudyChange: (index: number, value: string) => void
}

export const EducationalRequirementsSection = ({
    isEditMode,
    educationRequirements,
    qualifications,
    qualificationsStatus,
    fieldsOfStudy,
    fieldsOfStudyStatus,
    otherFieldOfStudyOption,
    addEducationRequirement,
    removeEducationRequirement,
    handleEducationRequirementChange,
    handleFieldOfStudyChange,
}: EducationalRequirementsSectionProps) => (
    <section className="mb-10">
        <div className="bg-[#E6EDDD] p-4 flex items-center justify-between rounded-md mb-6">
            <div className="flex items-center gap-3">
                <LayoutGrid className="w-5 h-5 text-gray-700" />
                <h2 className="font-bold text-gray-800 tracking-tight">Educational requirements</h2>
            </div>
            {!isEditMode && (
                <Plus className="w-5 h-5 text-gray-700 cursor-pointer" onClick={addEducationRequirement} />
            )}
        </div>

        {educationRequirements.map((requirement, index) => (
            <div key={index} className="grid grid-cols-1 md:grid-cols-2 gap-x-8 mb-4">
                <FormField label="Qualification" required>
                    <StyledSelectDropdown
                        options={qualifications}
                        value={requirement.qualificationId || ""}
                        onChange={(value) => handleEducationRequirementChange(index, "qualificationId", value)}
                        placeholder="Select qualification"
                        disabled={qualificationsStatus === "loading" || isEditMode}
                    />
                </FormField>
                <FormField label="Field of study" required>
                    <StyledSelectDropdown
                        options={[
                            ...fieldsOfStudy,
                            ...(requirement.fieldOfStudyOtherName
                                ? [{ id: requirement.fieldOfStudyOtherName, name: requirement.fieldOfStudyOtherName }]
                                : []),
                            otherFieldOfStudyOption,
                        ]}
                        value={requirement.fieldOfStudyOtherName || requirement.fieldOfStudyId || ""}
                        onChange={(value) => handleFieldOfStudyChange(index, value)}
                        placeholder="Select field of study"
                        disabled={fieldsOfStudyStatus === "loading" || isEditMode}
                    />
                </FormField>
                {educationRequirements.length > 1 && !isEditMode && (
                    <div className="flex justify-end col-span-2">
                        <button
                            type="button"
                            className="text-red-400 text-xs mt-1 font-medium"
                            onClick={() => removeEducationRequirement(index)}
                        >
                            Remove
                        </button>
                    </div>
                )}
            </div>
        ))}
        {!isEditMode && (
            <p className="mt-2 text-paragraph font-bold text-gray-500">To add more Requirements click the + icon.</p>
        )}
    </section>
)
